define('viewmodels/modals/dialogs/ViewModelDialog',[],function () {

    var ViewModelDialog = function (dialog, viewmodel, title) {

        this.title = title || viewmodel.title;

        this.viewmodel = viewmodel;

        this.show = function() {
            return dialog.showDialog(this);
        };

        this.close = function() {
            return dialog.close.apply(dialog, [this, arguments]);
        };
    };

    return ViewModelDialog;
});

